




















































import { DatePickerOptions } from "element-ui/types/date-picker";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InvoiceAddVue from "./InvoiceAdd.vue";
import { mapGetters } from "vuex";
import version from "@/version";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "invoice-add": InvoiceAddVue,
    }
})
export default class InvoiceScan extends Vue {
    @Prop()
    period!: string;
    @Prop()
    isProviderOrCustomer!: number;
    @Prop({ default: false })
    isJournal!: boolean;

    url = this.isJournal ? "journal" : "invoice";
    // payload = this.isJournal ? "" : `&isProviderOrCustomer=${this.isProviderOrCustomer}&page=0&size=100`;
    // dateVal: string = this.$utils.simpleDateFormat(this.$utils.strToDate(this.$store.state.accountBook.currentPeriod), "m");
    fileList: { name: string; url: string; status: string; result?: string; percentage?: number; progress?: number; size: number; }[] = [];
    resList: { id: number; name: string; url: string; status: string; result?: string; percentage?: number; progress?: number; size: number; }[] = [];

    mounted() {
        this.fetchResult();
    }

    getFile(file: File) {
        for (let i = 0; i < this.fileList.length; i++) {
            // @ts-ignore
            if (this.fileList[i].uid === file.uid) {
                return {
                    index: i,
                    file: this.fileList[i]
                };
            }
        }
    }
    beforeUpload(file: File) {
        if (file.size > 2097152) {
            const currentFile = this.getFile(file);
            if (currentFile) {
                currentFile.file.name = `文件大于 2M，请压缩图片 \n ${currentFile.file.name}`;
                currentFile.file.status = "size";
            }
        }
        return true;
    }
    async uploadFile(arg: { file: File; percentage: number }) {
        let data = new FormData();
        // let isProviderOrCustomer = this.importChange ? "0" : "1";
        data.append("file", arg.file);
        data.append("accountId", this.$store.state.account.id);
        data.append("accountBookId", this.$store.state.accountBook.id);
        data.append("period", this.period);
        data.append("fileName", arg.file.name);
        if (!this.isJournal) data.append("isProviderOrCustomer", this.isProviderOrCustomer.toString());
        arg.percentage = 0.5;
        // arg.status = "progress";
        const currentFile = this.getFile(arg.file);
        const prefix = "上传中...";

        if (currentFile) {
            if (currentFile.file.size <= 2097152) {
                try {
                    currentFile.file.name = `${prefix} ${currentFile.file.name}`;
                    const res = await Vue.axios.post(`${this.url}/import/image`, data);
                    currentFile.file.name = currentFile.file.name.replace(prefix + " ", "");
                    if (res.data.code !== 200) {
                        currentFile.file.name = `${currentFile.file.name}`;
                        currentFile.file.result = `${res.data.message}`;
                        currentFile.file.status = "fail";
                        currentFile.file.percentage = 1;
                    } else {
                        currentFile.file.name = `${currentFile.file.name}`;
                        currentFile.file.result = res.data.message;
                        currentFile.file.percentage = 1;
                        this.$notify({
                            type: "success",
                            message: `${currentFile.file.name}`,
                            title: res.data.message
                        });
                    }
                } catch (e) {
                    currentFile.file.name = `${e.response.data.message} \n ${currentFile.file.name.replace(prefix + " ", "")}`;
                    currentFile.file.result = "上传失败, 请稍候再试";
                    currentFile.file.status = "fail";
                    currentFile.file.percentage = 1;
                }
            } else {
                currentFile.file.name = `${currentFile.file.name}`;
                currentFile.file.result = "文件大于 2M，请压缩图片后再上传";
                currentFile.file.status = "fail";
            }
        }
    }
    async remove(id: number) {
        await Vue.axios.post(`${this.url}/image/delete?id=${id}`);
        this.fetchResult();
    }

    async fetchResult() {
        // const url = this.isJournal ? "journal" : "invoice";
        const res = await Vue.axios.get(`${this.url}/image/list?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&isProviderOrCustomer=${this.isProviderOrCustomer}&page=0&size=100`);
        this.resList = [];
        res.data.data.content.forEach((f: any) => {
            this.resList.push({
                url: f.url,
                status: f.isSuccess === 0 ? "fail" : "success",
                size: 0,
                id: f.id,
                name: f.fileName,
                result: f.message
            });
        });
    }

    async uploadChange(file: any, fileList: any[]) {
        if (file.result === "error") {
            file.status = "fail";
        }
        this.fileList = fileList;
        await this.fetchResult();
    }

    editVisible = false;
    editData: any = null;
    editTitle = "";
    async edit(id: number) {
        const res = await Vue.axios.get(`${this.url}/image/edit?id=${id}`);
        this.editData = res.data.data;
        if (res.data.data !== null) {
            this.editVisible = true;
            this.editTitle = (this.editData.isProviderOrCustomer === "0" ? "销" : "进") + "项发票";
        }
    }

    async download(file: any) {
        const url = `${Vue.axios.defaults.baseURL}export/${this.url}/ocr?token=${this.$store.state.account.token}&version=${version}&id=${file.id}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    async importFile(file: any) {
        if (!this.isJournal) {
            const res = await Vue.axios.post(`${this.url}/image/import?id=${file.id}`, { a: 1 });

            this.$notify({
                type: "success",
                message: res.data.data,
                title: res.data.message
            });
        } else {
            await this.getBanks();
            this.currentFile = file;
            this.openBankVisible = true;
        }
    }

    openBankVisible = false;
    openingBank = "";
    banks: string[] = [];
    currentFile: any = null;
    async getBanks() {
        const res = await Vue.axios.post(`journals/openingbanks?accountBookId=${this.$store.state.accountBook.id}`);
        Object.keys(res.data.openingBanks).forEach(e => {
            this.banks.push(e);
        });
        if (this.banks.length > 0) this.openingBank = this.banks[0];
        else this.openingBank = "";
    }
    /** 
     * 导入流水 
     * */
    async importBank() {
        const res = await Vue.axios.post(`${this.url}/image/import?id=${this.currentFile.id}&openingBank=${this.openingBank}`, { a: 1 });

        this.$notify({
            type: "success",
            message: res.data.data,
            title: res.data.message
        });
        this.openBankVisible = false;
        this.$notify({
            type: "success",
            title: res.data.message,
            message: res.data.data
        });
    }
}
